<template>
  <div>
    <wrapper>
        <styled-title>Arpegiator!</styled-title> 
        <div>({{bpm}} BPM's)</div>
        <input class="mdl-slider mdl-js-slider" type="range"
            min="50" max="180" tabindex="0"
            v-bind:value="bpm"
            v-on:input="updateBPM($event)"
            >
        
        
        <button @click="start">Start</button>
        <button @click="stop">Stop</button>
        <div class="row">

            <div <div v-for="row in rows" class="column">
                <div v-for="step in steps" :key="step.id + '-' + row ">
                    <button v-if="step.on[row] === true" class="toggled" @click="toggle(step.id, row)">{{step.id}}</button>
                    <button v-else class="untoggled" @click="toggle(step.id, row)">{{step.id}}</button>
                </div>
            </div> 
        </div>
    </wrapper>
  </div>
  
</template>
<script>

import Tone from 'tone'
import Vue from 'vue'

export default {
    data () {
        return {  
            rows: [0,1,2],
            bpm: 120,
            steps: [
                {
                    id: 1,
                    on: [false, false, false] 
                },
                {
                    id: 2,
                    on: [false, false, false]
                },
                {
                    id: 3,
                    on: [false, false, false]
                },
                {
                    id: 4,
                    on: [false, false, false]
                },
                {
                    id: 5,
                    on: [false, false, false]
                },
                {
                    id: 6,
                    on: [false, false, false]
                },
                {
                    id: 7,
                    on: [false, false, false]
                },
                {
                    id: 8,
                    on: [false, false, false]
                }
            ]
        }
    },
    methods: {
        updateBPM(evt) {
            this.bpm = evt.target.value
            Tone.Transport.bpm.value = this.bpm
        },
        toggle(id, col) {
            console.log(id, col)
            let stepButton = this.steps.find(s => s.id == id)
            stepButton.on[col] = !stepButton.on[col]
            Vue.set(this.steps, this.steps.indexOf(stepButton), stepButton)
        },
        stop(){
            Tone.Transport.stop()
        },
        start () {
            const notes = ['C4', 'Eb4', 'G4']

            /*
            const synths = [
                new Tone.Synth(),
                new Tone.Synth(),
                new Tone.MembraneSynth()
            ]
            */

           const synths = [
                new Tone.Synth(),
                new Tone.Synth(),
                new Tone.Synth()
            ]

            synths[0].oscillatorType = 'triangle'
            synths[1].oscillatorType = 'triangle'
            synths[2].oscillatorType = 'triangle'

            synths.forEach(synth => synth.toMaster())

            
            Tone.Transport.scheduleRepeat(repeat, '8n')
            Tone.Transport.bpm.value = this.bpm;
            Tone.Transport.start()

            let index = 0
            
            //view model for nested reference
            var vm = this;

            function repeat(time) {
                let step = index % 8
                for (let i = 1; i < 9 ; i++ ) {
                    let button = vm.steps.find(s => s.id == i )
                    if (step === button.id && button.on[0]) synths[0].triggerAttackRelease(notes[0], '8n', time)
                    if (step === button.id && button.on[1]) synths[1].triggerAttackRelease(notes[1], '8n', time)
                    if (step === button.id && button.on[2]) synths[2].triggerAttackRelease(notes[2], '8n', time)
                }

                index++
            }

        }
    }
}
</script>
<style scoped>

.toggled{
    background-color: #c3375b;
}
.untoggled{
    background-color: none;
}

.row{
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
    justify-content: space-around;
}

.column{
    display: flex;
    flex-direction: column;
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/MetronomeView.vue